export type CityProfileId = 'sofia' | 'default'

export interface CityDeliveryRules {
  aliases: string[]
  courierRequired: boolean
  showElevator: boolean
  showBringToDoor: boolean
  showAddressComment: boolean
  floorRequired: boolean
  showBuildingDetails: boolean
  showContactless: boolean
  showCallBeforeArrival: boolean
  showDeliveryCommentPlaceholder: boolean
  showCashOnDelivery: boolean
  skipEarliestDeliveryDay: boolean
  deliveryDayCount: number
}

const sofiaRules: CityDeliveryRules = {
  aliases: ['софи', 'sofi', 'софия', 'sofia', 'софиа', 'sofiq', 'sofiya'],
  courierRequired: false,
  showElevator: true,
  showBringToDoor: true,
  showAddressComment: true,
  floorRequired: true,
  showBuildingDetails: true,
  showContactless: true,
  showCallBeforeArrival: true,
  showDeliveryCommentPlaceholder: true,
  showCashOnDelivery: true,
  skipEarliestDeliveryDay: false,
  deliveryDayCount: 4,
}

const defaultRules: CityDeliveryRules = {
  aliases: [],
  courierRequired: true,
  showElevator: false,
  showBringToDoor: false,
  showAddressComment: false,
  floorRequired: false,
  showBuildingDetails: true,
  showContactless: false,
  showCallBeforeArrival: false,
  showDeliveryCommentPlaceholder: false,
  showCashOnDelivery: false,
  skipEarliestDeliveryDay: true,
  deliveryDayCount: 3,
}

export const CITY_DELIVERY_PROFILES: Record<CityProfileId, CityDeliveryRules> = {
  sofia: sofiaRules,
  default: defaultRules,
}

export function normalizeCityName(city: string): string {
  return city.trim().toLowerCase()
}

export function resolveCityProfile(city: string): CityProfileId {
  const normalized = normalizeCityName(city)
  if (!normalized) return 'default'

  for (const [id, rules] of Object.entries(CITY_DELIVERY_PROFILES) as [CityProfileId, CityDeliveryRules][]) {
    if (id === 'default') continue
    if (rules.aliases.some(alias => normalized.includes(alias))) return id
  }

  return 'default'
}

export function getCityDeliveryRules(city: string): CityDeliveryRules {
  return CITY_DELIVERY_PROFILES[resolveCityProfile(city)]
}
